var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.10011 13.9001C7.60011 13.9001 7.00011 13.9001 6.50011 13.9001C6.20011 13.9001 5.90011 13.7001 5.90011 13.3001C6.00011 12.2001 5.50011 11.2001 4.80011 10.4001C3.40011 8.80015 3.60011 6.00015 5.60011 4.60015C7.20011 3.40015 9.50011 3.50015 11.0001 4.80015C12.6001 6.20015 12.9001 8.70015 11.5001 10.4001C11.3001 10.6001 11.1001 10.9002 10.9001 11.1002C10.5001 11.7002 10.3001 12.3001 10.3001 13.0001C10.3001 13.1002 10.3001 13.2001 10.3001 13.3001C10.3001 13.6002 10.1001 13.8001 9.80011 13.8001C9.20011 13.9002 8.70011 13.9001 8.10011 13.9001Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.39995 15.1001C9.39995 15.5001 9.39995 15.8001 9.39995 16.1001C8.49995 16.1001 7.59995 16.1001 6.69995 16.1001C6.69995 15.8001 6.69995 15.4001 6.69995 15.1001C7.59995 15.1001 8.49995 15.1001 9.39995 15.1001Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3999 1.7998C13.6999 2.0998 13.8999 2.2998 14.1999 2.5998C13.6999 3.0998 13.1999 3.5998 12.5999 4.1998C12.2999 3.9998 12.0999 3.6998 11.8999 3.4998C12.3999 2.8998 12.8999 2.2998 13.3999 1.7998Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.6 0C8.6 0.7 8.6 1.5 8.6 2.2C8.2 2.2 7.9 2.2 7.5 2.2C7.5 1.5 7.5 0.8 7.5 0C7.9 0 8.3 0 8.6 0Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.6 4.1998C3 3.5998 2.5 2.9998 2 2.4998C2.2 2.2998 2.5 2.0998 2.7 1.7998C3.2 2.2998 3.8 2.7998 4.3 3.2998C4.1 3.5998 3.8 3.8998 3.6 4.1998Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.3 7.2002C2.3 7.6002 2.3 7.9002 2.3 8.2002C1.5 8.2002 0.8 8.2002 0 8.2002C0 7.8002 0 7.5002 0 7.2002C0.8 7.2002 1.5 7.2002 2.3 7.2002Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.8999 7.2002C14.5999 7.2002 15.3999 7.2002 16.0999 7.2002C16.0999 7.5002 16.0999 7.9002 16.0999 8.3002C15.3999 8.3002 14.5999 8.3002 13.8999 8.3002C13.8999 7.9002 13.8999 7.6002 13.8999 7.2002Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.2 13C13.9 13.3 13.7 13.5 13.4 13.8C12.9 13.3 12.3 12.8 11.8 12.2C12.1 12 12.3 11.7 12.6 11.5C13.2 12 13.7 12.5 14.2 13Z",
    fill: "#EE8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.8 13.7C2.5 13.5 2.3 13.2 2 13C2.5 12.5 3 12 3.6 11.5C3.8 11.8 4.1 12 4.3 12.3C3.8 12.7 3.3 13.2 2.8 13.7Z",
    fill: "#EE8B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/bulbIcon.19d8d085357d8836e5c8edbd3352f2ee.svg";
export { ForwardRef as ReactComponent };